'use client';

import dynamic from 'next/dynamic';

import { type DonationChartProps } from './donation-chart';

const DonationChart = dynamic(
  async () => {
    const { DonationChart: Component } = await import('./donation-chart');
    return { default: Component };
  },
  { ssr: false }
);

export const DonationChartLoader = (props: DonationChartProps) => <DonationChart {...props} />;
